import { render, staticRenderFns } from "./ModalCourseMap.vue?vue&type=template&id=6b44fd5f&scoped=true&"
import script from "./ModalCourseMap.vue?vue&type=script&lang=ts&"
export * from "./ModalCourseMap.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCourseMap.vue?vue&type=style&index=0&id=6b44fd5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44fd5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6b44fd5f', component.options)
    } else {
      api.reload('6b44fd5f', component.options)
    }
    module.hot.accept("./ModalCourseMap.vue?vue&type=template&id=6b44fd5f&scoped=true&", function () {
      api.rerender('6b44fd5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/ModalCourseMap.vue"
export default component.exports